import { render, staticRenderFns } from "./FxTag.vue?vue&type=template&id=ccb57226&"
import script from "./FxTag.vue?vue&type=script&lang=js&"
export * from "./FxTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports